import { formatCents } from "@caloteiros/shared";

export interface ShareTransfer {
  fromName: string;
  toName: string;
  amountCents: number;
  pixKey?: string | null;
}

/** O texto que vai para o grupo do WhatsApp depois do rolê. */
export function buildSummaryText(groupName: string, transfers: ShareTransfer[]): string {
  if (transfers.length === 0) {
    return `*${groupName}* — está tudo quitado! 🎉`;
  }

  const lines = transfers.map((transfer) => {
    const pix = transfer.pixKey ? `\n   Pix: ${transfer.pixKey}` : "";
    return `• ${transfer.fromName} paga ${formatCents(transfer.amountCents)} para ${transfer.toName}${pix}`;
  });

  return [`*${groupName}* — acerto de contas`, "", ...lines, "", "_via Caloteiros_"].join("\n");
}

export function openWhatsApp(text: string): void {
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
}

/** Copia para a area de transferencia, com plano B para navegador antigo. */
export async function copyToClipboard(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(textarea);
    return copied;
  }
}

/** Escapa aspas e separadores para o CSV nao quebrar no Excel. */
function csvCell(value: string | number): string {
  const text = String(value);
  return /[";\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function downloadCsv(filename: string, rows: (string | number)[][]): void {
  // Ponto e virgula e BOM: e o que o Excel em portugues espera.
  const content = `\uFEFF${rows.map((row) => row.map(csvCell).join(";")).join("\n")}`;
  const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
